export default __webpack_public_path__ + "static/media/no_graph.5723980d.png";